<template>
  <div
    v-if="modalIsOpened"
    id="teamInfoModal"
    class="fixed inset-0 w-full bg-black/30 z-51"
  >
    <div
      class="fixed inset-0 overflow-y-auto flex items-start justify-center py-8"
      @click.self="closeModal"
    >
      <div class="w-[100vw] max-w-[1000px] min-h-[690px] max-h-[690px] px-[20px] overflow-hidden m-auto">
        <!-- actual modal -->
        <div
          class="h-full mx-auto box-effect rounded-[10px] bg-white overflow-hidden"
        >
          <div
            class="flex flex-col justify-center items-start gap-[22px] p-[20px] pl-[36px] pr-[24px]"
          >
            <div
              class="w-full flex items-center justify-between gap-[10px] flex-wrap sm:flex-wrap"
            >
              <div class="flex items-center gap-[10px]">
                <div class="flex items-center gap-[6px]">
                  <!-- icon -->
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="21"
                    height="23"
                    viewBox="0 0 21 23"
                    fill="none"
                  >
                    <path
                      d="M11.6486 1.7447C11.3792 0.925684 10.6074 0.333252 9.69931 0.333252C8.79123 0.333252 8.01937 0.925684 7.75 1.7447C9.0265 1.43447 10.3711 1.43425 11.6486 1.7447Z"
                      fill="#9B237B"
                    />
                    <path
                      d="M12.562 21.158H6.83594C8.20604 23.1938 11.1912 23.1948 12.562 21.158Z"
                      fill="#9B237B"
                    />
                    <path
                      d="M18.0415 16.9812C17.1657 16.3975 16.6427 15.4204 16.6427 14.3679V12.8193H10.8507C9.51867 12.8193 8.43509 11.7358 8.43509 10.4038C8.43509 9.98771 8.54336 9.5769 8.74768 9.21498L12.1163 3.2553C11.3641 2.97502 10.5503 2.82178 9.70115 2.82178C5.87371 2.82178 2.75962 5.93586 2.75962 9.76331V14.3679C2.75962 15.4204 2.2366 16.3975 1.36084 16.9812C0.924697 17.272 0.664062 17.7587 0.664062 18.2835C0.664062 19.1462 1.36607 19.8482 2.22875 19.8482H17.1736C18.0362 19.8482 18.7382 19.1462 18.7382 18.2835C18.7382 17.7587 18.4776 17.272 18.0415 16.9812Z"
                      fill="#9B237B"
                    />
                    <path
                      d="M20.0774 9.85922L16.0239 2.68761C15.5661 1.87768 14.397 1.87811 13.9394 2.68761L9.88593 9.85922C9.47301 10.5898 9.99765 11.5096 10.8489 11.5096H19.1145C19.9642 11.5096 20.4913 10.5915 20.0774 9.85922ZM14.3268 5.22288C14.3268 4.86123 14.6201 4.56802 14.9817 4.56802C15.3434 4.56802 15.6366 4.86123 15.6366 5.22288V6.96918C15.6366 7.33084 15.3434 7.62404 14.9817 7.62404C14.6201 7.62404 14.3268 7.33084 14.3268 6.96918V5.22288ZM14.9817 9.71982C14.6201 9.71982 14.3266 9.4264 14.3266 9.06474C14.3266 8.70308 14.6201 8.40966 14.9817 8.40966C15.3434 8.40966 15.6368 8.70308 15.6368 9.06474C15.6368 9.4264 15.3434 9.71982 14.9817 9.71982Z"
                      fill="#9B237B"
                    />
                  </svg>
                  <!-- icon -->
                  <span class="PC_H2-SB text-[#1F1D1F]"> แจ้งเตือน </span>
                </div>
                <ButtonComponent
                  v-if="!deleteStage"
                  :icon="'TrashcanIcon'"
                  :bClass="'btn_shadow--2 !min-w-[36px] !max-w-[36px] !h-[36px]'"
                  :iClass="'!w-[20px] !h-[20px]'"
                  @clicked="
                    () => {
                      deleteStage = true;
                    }
                  "
                />
              </div>
              <ButtonComponent
                v-if="!deleteStage"
                :icon="'XIcon'"
                :bClass="'btn_shadow--2 !min-w-[36px] !max-w-[36px] !h-[36px]'"
                :iClass="'!w-[20px] !h-[20px]'"
                @clicked="closeModal"
              />
              <div
                v-if="deleteStage"
                class="hidden sm:flex items-center gap-[10px] flex-wrap sm:flex-wrap"
              >
                <div
                  @click="deleteBulk"
                  class="btn_s btn_s--cancel max-w-[146px]"
                  :class="notification_selected.length <= 0 ? 'disabled' : ''"
                >
                  <span>
                    ต้องการลบ {{ notification_selected.length }} รายการ
                  </span>
                </div>
                <ButtonComponent
                  :label="'ลบทั้งหมด'"
                  :bClass="'btn_shadow--cancel min-w-[88px] !max-w-[88px] !h-[42px] !px-[0px]'"
                  @clicked="deleteAll"
                />
                <ButtonComponent
                  :label="'ยกเลิก'"
                  :bClass="'btn_shadow--cancel min-w-[76px] !max-w-[76px] !h-[42px] !px-[0px]'"
                  @clicked="
                    () => {
                      deleteStage = false;
                      unSelectNotification();
                    }
                  "
                />
              </div>
            </div>
            <div
              v-if="deleteStage"
              class="flex sm:hidden items-center gap-[10px] flex-wrap sm:flex-wrap"
            >
              <div
                @click="deleteBulk"
                class="btn_s btn_s--cancel max-w-[146px]"
                :class="notification_selected.length <= 0 ? 'disabled' : ''"
              >
                <span>
                  ต้องการลบ {{ notification_selected.length }} รายการ
                </span>
              </div>
              <ButtonComponent
                :label="'ลบทั้งหมด'"
                :bClass="'btn_shadow--cancel min-w-[88px] !max-w-[88px] !h-[42px] !px-[0px]'"
                @clicked="deleteAll"
              />
              <ButtonComponent
                :label="'ยกเลิก'"
                :bClass="'btn_shadow--cancel min-w-[76px] !max-w-[76px] !h-[42px] !px-[0px]'"
                @clicked="
                  () => {
                    deleteStage = false;
                    unSelectNotification();
                  }
                "
              />
            </div>
            <!-- List -->
            <div
              ref="listRef"
              class="w-full flex flex-col items-start gap-[10px] overflow-auto"
              :class="deleteStage ? 'min-h-[586px] max-h-[586px]' : 'min-h-[592px] max-h-[592px]'"
              @scroll="onScroll"
            >
              <div
                v-for="(row, rowIndex) in tableDataMap"
                :key="rowIndex"
                class="w-full flex items-center gap-[10px]"
              >
                <CheckBox2
                  v-if="deleteStage"
                  :isLabel="false"
                  :value="row.selected"
                  @value="() => selectNotification(row)"
                />
                <div
                  class="min-w-[76px] flex flex-col items-end justify-center gap-[4px]"
                >
                  <div class="PC_Body2-R text-[#1F1D1F]">
                    {{ $formatDate1(row.created_at) }}
                  </div>
                  <div class="PC_Body2-R text-[#1F1D1F]">
                    {{ `${$formatTime1(row.created_at)} น.` }}
                  </div>
                </div>
                <div
                  class="w-full flex items-center justify-between gap-[16px] p-[10px] rounded-[6px] border-[1px] border-solid border-[#F3F2F2] bg-[#FFF]"
                  :class="!row.is_read ? 'newNotification' : ''"
                >
                  <div class="flex flex-col items-start gap-[6px]">
                    <div class="PC_Body1-SB text-[#1F1D1F]">
                      {{ row.notification?.title }}
                    </div>
                    <div class="break-words whitespace-normal">
                      <span
                        v-for="(format, formatIndex) in row.notification
                          ?.format"
                        :key="formatIndex"
                        :class="[
                          format.type == 'text'
                            ? 'PC_Body2-R text-[#7C7379]'
                            : 'PC_Body2-SB text-[#1F1D1F]',
                          'break-words mr-[3px]',
                        ]"
                      >
                        {{ format.content }}
                      </span>
                    </div>
                  </div>
                  <div
                    v-if="!deleteStage && row.show_details"
                    class="min-w-[95px] h-[42px] flex items-center justify-center flex-nowrap gap-[4px] p-[16px] rounded-[6px] border-[1px] border-solid border-[#9B237B] bg-[#FBEFF8] hover:bg-[#EECCE7] text-[#9B237B] cursor-pointer"
                    @click="() => detail(row)"
                  >
                    <span class="ButtonS"> รายละเอียด </span>
                  </div>
                </div>
              </div>
            </div>
            <!-- List -->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script setup>
import { ref, computed } from "vue";
import { useRouter } from "vue-router";
import { useNotificationStore } from "@/pinia/notification";
import { useProductStore } from "@/pinia/product";
import { useAuthStore } from "@/pinia/authStore";
// โรล
import { ROLES } from "@/components/Utilities/javascripts/permissions";

const router = useRouter();
const notificationStore = useNotificationStore();
const productStore = useProductStore();
const auth = useAuthStore();

const deleteStage = ref(false);
const tableData = ref([]);
const tableDataMap = ref([]);
const notification_selected = ref([]);
const modalIsOpened = ref(false);

const listRef = ref(null);

const filter = ref({
  offset: 0,
  limit: 100,
});
const isLoading = ref(false);
const hasMore = ref(true);
let scrollLock = false;

const emit = defineEmits(["headInfo", "info"]);

const selectedItems = computed(() =>
  tableDataMap.value.filter((row) => row.selected === true && row.id != null)
);

const selectedIds = computed(() => [
  ...new Set(selectedItems.value.map((r) => r.id)),
]);

const getData = async ({ append = false } = {}) => {
  if (isLoading.value) return;
  isLoading.value = true;

  try {
    const response = await notificationStore.getAllNotification({
      offset: filter.value.offset,
      limit: filter.value.limit,
    });

    if (response.status === 200) {
      const rows = Array.isArray(response.data?.data) ? response.data.data : [];

      if (append) {
        tableData.value = [...tableData.value, ...rows];
      } else {
        tableData.value = rows;
      }

      tableDataMap.value = tableData.value.map((item) => ({
        ...item,
        selected: item.selected ?? false,
      }));

      hasMore.value = rows.length >= filter.value.limit;
    }
  } catch (error) {
    //
  } finally {
    isLoading.value = false;
  }
};

const openModal = async () => {
  modalIsOpened.value = true;
  document.body.style.overflow = "hidden";

  filter.value.offset = 0;
  hasMore.value = true;
  tableData.value = [];
  tableDataMap.value = [];
  notification_selected.value = [];
  deleteStage.value = false;

  await getData({ append: false });

  try {
    await notificationStore.readAllNotification();
  } catch (e) {
    // ไม่ให้ล้มทั้งหน้า
  }
};

const closeModal = () => {
  modalIsOpened.value = false;
  document.body.style.overflow = "auto";
};

const onScroll = async (e) => {
  const el = e.target;
  const threshold = 40;
  const atBottom =
    el.scrollTop + el.clientHeight >= el.scrollHeight - threshold;

  if (atBottom && !isLoading.value && hasMore.value && !scrollLock) {
    scrollLock = true;
    try {
      filter.value.offset += filter.value.limit;
      await getData({ append: true });
    } finally {
      setTimeout(() => (scrollLock = false), 200);
    }
  }
};

const selectNotification = (item) => {
  const exists = notification_selected.value.find((cg) => cg.id === item.id);
  if (!exists) {
    item.selected = true;
    notification_selected.value.push(item);
  }
};

const unSelectNotification = () => {
  if (notification_selected.value.length !== 0) {
    notification_selected.value = [];
    tableDataMap.value.forEach((cg) => (cg.selected = false));
  }
};

const reloadFromStart = async () => {
  filter.value.offset = 0;
  hasMore.value = true;
  tableData.value = [];
  tableDataMap.value = [];
  await getData({ append: false });
};

const deleteBulk = async () => {
  const body = {
    notification_id: selectedIds.value,
  };
  try {
    const response = await notificationStore.deleteBulkNotification(body);
    if (response.status === 200) {
      unSelectNotification();
      deleteStage.value = false;
      await reloadFromStart();
    }
  } catch (error) {
    // handle error
  }
};

const deleteAll = async () => {
  try {
    const response = await notificationStore.deleteAllNotification();
    if (response.status === 200) {
      unSelectNotification();
      deleteStage.value = false;
      await reloadFromStart();
    }
  } catch (error) {
    // handle error
  }
};

const detail = async (data) => {
  console.log("data", data);

  if (data.event_type == "damaged") {
    // 1. แจ้งเตือนสาธารณประโยชน์ที่ได้รับความเสียหาย -> ไปหน้า dashboard + popup ตาม type
    const body = {
      type: data.related_data?.type, // 1,2,3,4
      popup_name: "damaged",
    };
    localStorage.setItem("popup", JSON.stringify(body));
    router.push({
      path: "/dashboard",
      query: {
        popup: data.related_data?.type,
        ts: Date.now(),
      },
    });
  } else if (data.event_type == "product_request") {
    // 2. แจ้งเตือนคำร้องขอทรัพยากรส่วนกลาง -> ไปหน้า resource
    if (data.event_action == "created") {
      const res = await productStore.getProductRequestById(
        data.related_data?.product_id
      );
      const body = {
        ...res?.data?.data,
        popup_name: "created",
      };
      localStorage.setItem("popup", JSON.stringify(body));
      router.push({
        path: "/dashboard",
        query: {
          popup: "created",
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "product") {
    // 3. แจ้งเตือนได้รับทรัพยากรส่วนกลาง -> ไปหน้า resource
    if (data.event_action == "received") {
      localStorage.setItem("popup", JSON.stringify("received"));
      router.push({
        path: "/resource",
        query: {
          popup: "received",
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "shelter_product") {
    // 4. แจ้งเตือนได้รับทรัพยากรภายในศูนย์
    if (data.event_action == "received") {
      const body = {
        ...data.related_data,
        id: data.related_data?.to_shelter_id,
      };
      const name = data.related_data?.to_shelter_name;
      sessionStorage.setItem("shelterID", JSON.stringify(body));
      localStorage.setItem("popup", JSON.stringify("received"));
      router.push({
        path: `/shelter/${name}/resources`,
        query: {
          popup: "received",
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "emergency_request") {
    // 5. แจ้งเตือนเหตุฉุกเฉิน -> ไปหน้ารายละเอียดแจ้งเหตุฉุกเฉิน
    const id = data.entity_id;
    localStorage.setItem("emReqHistoryID", JSON.stringify(id));
    if (data.event_action == "created" || data.event_action == "rejected") {
      router.push({
        path: `/emergency-requests/reporter-detail/${id}`,
        query: {
          ts: Date.now(),
        },
      });
    } else if (data.event_action == "assigned") {
      router.push({
        path: `/emergency-requests/waiting-lists-reporter-detail/${id}`,
        query: {
          ts: Date.now(),
        },
      });
    } else if (
      data.event_action == "success" ||
      data.event_action == "unsuccess"
    ) {
      router.push({
        path: `/emergency-requests/emergency-request-history/${id}`,
        query: {
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "news") {
    // 6. แจ้งเตือนข่าวประชาสัมพันธ์
    const body = {
      ...data.related_data,
      id: data.related_data?.entity_id,
    };
    const name = data.related_data?.entity_name;
    localStorage.setItem("newID", JSON.stringify(body));
    router.push({
      path: `/public-relations/${name}`,
      query: {
        ts: Date.now(),
      },
    });
  } else if (data.event_type == "shelter_news") {
    // 7. แจ้งเตือนข่าวประชาสัมพันธ์ภายในศูนย์
    const body = {
      ...data.related_data,
      id: data.related_data?.shelter_id,
    };
    sessionStorage.setItem("shelterID", JSON.stringify(body));
    const body1 = {
      ...data.related_data,
      id: data.related_data?.entity_id,
    };
    localStorage.setItem("newID", JSON.stringify(body1));
    router.push({
      path: `/shelter/${data.related_data?.shelter_name}/${data.related_data?.entity_name}`,
      query: {
        ts: Date.now(),
      },
    });
  } else if (data.event_type == "user") {
    // 8. แจ้งเตือนผู้ใช้งานขอลงทะเบียน
    if (data.event_action == "registered") {
      const body = {
        ...data.related_data,
        id: data.related_data?.entity_id,
      };
      const name = data.related_data.entity_name;
      localStorage.setItem("ID", JSON.stringify(body));
      router.push({
        path: `/pending-approval-list/${name}`,
        query: {
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "appointment") {
    // 9. แจ้งเตือนนัดหมาย
    // if (data.event_action == "shelter") {
    if (auth.hasRole([ROLES.staff]) || data.event_action == "shelter") {
      const body = {
        ...data.related_data,
        id: data.related_data?.shelter_id,
      };
      sessionStorage.setItem("shelterID", JSON.stringify(body));
      const name = data.related_data?.shelter_name;
      router.push({
        path: `/shelter/${name}/medical-team-schedule`,
        query: {
          ts: Date.now(),
        },
      });
    } else {
      router.push({
        path: `/medical-team/checkup-schedule`,
        query: {
          ts: Date.now(),
        },
      });
    }
  } else if (data.event_type == "position") {
    // 10. แจ้งเตือนอัปเดต ระบบบัญชาการ -> dashboard + popup = position
    localStorage.setItem("popup", JSON.stringify("position"));
    router.push({
      path: `/dashboard`,
      query: {
        popup: "position",
        ts: Date.now(),
      },
    });
  } else if (data.event_type == "shelter_position") {
    // 11. แจ้งเตือนแผนผังการทำงาน ภายในศูนย์พักพิง
    const body = {
      ...data.related_data,
      id: data.related_data?.shelter_id,
    };
    sessionStorage.setItem("shelterID", JSON.stringify(body));
    localStorage.setItem("popup", JSON.stringify("workFlowChart"));
    router.push({
      path: `/shelter/${data.related_data?.shelter_name}`,
      query: {
        popup: "workFlowChart",
        ts: Date.now(),
      },
    });
  }

  // ปิด modal ทุกกรณี
  closeModal();
};

defineExpose({ openModal, closeModal });
</script>

<style lang="scss" scoped>
.ButtonS {
  color: #9b237b;
  text-align: center;
  /* Button/s */
  font-family: Kanit;
  font-size: 13px;
  font-style: normal;
  font-weight: 400;
  line-height: 20px; /* 153.846% */
  letter-spacing: 0.1px;
}

.btn_s {
  cursor: pointer;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 6px;
  text-decoration: none;

  border-radius: 6px;
  border: 1px solid;
  &--cancel {
    width: 100%;
    min-width: 160px;
    height: 42px;
    padding: 12px 20px;
    border-color: #b7b2b5;
    background: #fff;
    color: #1f1d1f;
    span {
      text-align: center;
      /* Button/s */
      font-family: Kanit;
      font-size: 13px;
      font-style: normal;
      font-weight: 400;
      line-height: 20px; /* 153.846% */
      letter-spacing: 0.1px;
    }
  }
  &.disabled {
    pointer-events: none;
    user-select: none;
    border-color: #dfdcdd;
    color: #b7b2b5;
    background: #fff;
    span {
      color: #b7b2b5;
    }
  }
}
.newNotification {
  border-radius: 6px !important;
  border: 1px solid #dfdcdd !important;
  background: #fbeff8 !important;
  box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.12) !important;
}
.wrap-container {
  display: block; /* ไม่จำเป็นต้อง flex */
  white-space: normal; /* ให้ตัดบรรทัดตามปกติ */
  word-wrap: break-word; /* รองรับคำยาวเกิน */
  overflow-wrap: break-word;
}

.wrap-span {
  display: inline; /* หรือ inline-block ก็ได้ */
  white-space: normal;
}
</style>